import { render } from "./CatalogTabs.vue?vue&type=template&id=bc461714&scoped=true"
import script from "./CatalogTabs.vue?vue&type=script&lang=js"
export * from "./CatalogTabs.vue?vue&type=script&lang=js"

import "./CatalogTabs.vue?vue&type=style&index=0&id=bc461714&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc461714"]])

export default __exports__